module.exports = __webpack_public_path__ + "static/media/excel.4f1098df.svg";